import React, { useEffect, useState } from "react";
import Error from "../../../shared/components/Error";
import { withTranslation } from "react-i18next";
import OtherAdultInHomeView from "./components/OtherAdultInHomeView";

const OtherAdultsLiving = ({ i18n }) => {
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (i18n?.language === "en") {
      document.title =
        "Other adults living in home - HARP - Government of Nova Scotia";
    } else {
      document.title =
        "Autres adultes vivant à la maison";
    }
  }, [i18n.language]);

  // useEffect(() => {
  //   try {
  //     addToGoogleDataLayer(
  //       "live-independently-check",
  //       "Grant Application",
  //       i18n.language
  //     );
  //     window.scrollTo(0, 0);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }, [i18n.language]);

  return isError ? <Error /> : <OtherAdultInHomeView setIsError={setIsError} />;
};

export default withTranslation("common")(OtherAdultsLiving);
